import { Result, Button } from 'antd';
import * as Sentry from '@sentry/browser';
import React from 'react';
import { PageLoading } from '@ant-design/pro-layout';
import { checkReloadApp } from '@/utils/versionCheck';

// chunk 错误加载重试次数
// const chunkErrorRetryCount = 'chunk_error_retry_count';

const chunkLoadErrorReg = /Loading chunk (\d)+ failed/g;

type ErrorBoundaryState = {
  /** 是否存在错误 */
  hasError: boolean;
  /** 存在错误时的错误信息 */
  errorInfo: string;
  /** 当 chunk load error 时，是否正在刷新页面 */
  chunkErrorLoading: boolean;
};

// eslint-disable-next-line @typescript-eslint/ban-types
class ErrorBoundary extends React.Component<{ children?: React.ReactNode }, ErrorBoundaryState> {
  state = { hasError: false, errorInfo: '', chunkErrorLoading: false };

  static getDerivedStateFromError(error: Error) {
    const errorState = {
      hasError: true,
      errorInfo: error.message,
      chunkErrorLoading: false,
    };

    if (error?.message?.match(chunkLoadErrorReg)) {
      // 检测 APP 是否有新版本，有的话主动刷新
      checkReloadApp({
        onCheckPass: () => {
          // 如果没有新版本，那么是其他原因导致，上报错误
          // 上报全局错误
          Sentry.captureException(error, {
            extra: {
              type: 'error boundary catch',
            },
          });
        },
      });
      return errorState;
    } else {
      // 上报全局错误
      Sentry.captureException(error, {
        extra: {
          type: 'error boundary catch',
        },
      });
      return errorState;
    }
  }

  handleClick = () => {
    window.location.reload();
  };

  render() {
    if (this.state.chunkErrorLoading) {
      return <PageLoading />;
    }

    if (this.state.hasError) {
      return (
        <Result
          status='error'
          title='Something went wrong.'
          extra={
            <div className='fx-dir fx-v-c'>
              <span>{this.state.errorInfo}</span>
              <Button type='primary' style={{ marginTop: 20 }} onClick={this.handleClick}>
                刷新页面
              </Button>
            </div>
          }
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
